import React from 'react';
import slider_img_1 from '../../assets/images/home/slider/doc-slider1.png';
import slider_img_2 from '../../assets/images/home/slider/doc-slider2.png';
import slider_img_3 from '../../assets/images/home/slider/doc-slider3.png';
  
const Slider = () => {
  return (
    <section className="slider">
      <div
        id="x_023_animated_layers"
        className="carousel slide x_023_animated_layers_indicators x_023_animated_layers_control_button thumb_scroll_x swipe_x ps_easeOutInCubic"
        data-bs-ride="carousel"
      >
        {/* Indicators */}
        <ol className="carousel-indicators">
          <li
            data-bs-target="#x_023_animated_layers"
            data-bs-slide-to="0"
            className="active"
            aria-current="true"
            aria-label="Slide 1"
          />
          <li
            data-bs-target="#x_023_animated_layers"
            data-bs-slide-to="1"
            aria-label="Slide 2"
          />
          <li
            data-bs-target="#x_023_animated_layers"
            data-bs-slide-to="2"
            aria-label="Slide 3"
          />
        </ol>

        {/* Slides */}
        <div
          className="carousel-inner"
          role="listbox"
          data-bs-touch="true"
          data-bs-pause="hover"
        >
          {/* Slide 1 */}
          <div className="carousel-item item active" data-bs-interval="4000">
            <div className="x_023_animated_layers_content">
              <div className="x_023_animated_layers_txt">
                <h1 className="animate__animated animate__fadeInLeft animate__delay-2s">
                  Medial Services that you can trust
                </h1>
                <p className="animate__animated animate__fadeInLeft animate__delay-2s">
                  Need professional help? Our support staff will answer your questions.
                </p>
                <p className="animate__animated animate__fadeInLeft animate__delay-2s">
                  Visit us Now or Make an Appointment!
                </p>
                <a
                  href="#"
                  className="btn mar-top-15 animate__animated animate__fadeInLeft animate__delay-2s"
                >
                  Make An Appointment
                </a>
              </div>

              <div className="x_023_animated_layers_img animate__animated animate__fadeInUp">
                <img
                  src={slider_img_2}
                  alt="Doctor Slide 1"
                />
              </div>
            </div>
          </div>

          {/* Slide 2 */}
          <div className="carousel-item item" data-bs-interval="4000">
            <div className="x_023_animated_layers_content x_023_animated_layers_content_right">
              <div className="x_023_animated_layers_txt">
                <h1 className="animate__animated animate__fadeInRight animate__delay-1s">
                  We make quality health care
                </h1>
                <p className="animate__animated animate__fadeInRight animate__delay-1s">
                  Passionate About Medicine. Compassionate About People.
                </p>
                <p className="animate__animated animate__fadeInRight animate__delay-1s">
                  Visit us Now or Make an Appointment!
                </p>
                <a
                  href="#"
                  className="btn mar-top-15 animate__animated animate__fadeInRight animate__delay-2s"
                >
                  Make An Appointment
                </a>
              </div>

              <div className="x_023_animated_layers_img animate__animated animate__fadeInUp">
                <img
                  src={slider_img_1}
                  alt="Doctor Slide 2"
                />
              </div>
            </div>
          </div>

          {/* Slide 3 */}
          <div className="carousel-item item" data-bs-interval="4000">
            <div className="x_023_animated_layers_content x_023_animated_layers_content_right">
              <div className="x_023_animated_layers_txt">
                <h1 className="animate__animated animate__fadeInRight animate__delay-1s">
                  Modern Technology Treatment
                </h1>
                <p className="animate__animated animate__fadeInRight animate__delay-1s">
                  Doctor’s for health
                </p>
                <p className="animate__animated animate__fadeInRight animate__delay-1s">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt.
                </p>
                <a
                  href="#"
                  className="btn mar-top-15 animate__animated animate__fadeInRight animate__delay-2s"
                >
                  Make An Appointment
                </a>
              </div>

              <div className="x_023_animated_layers_img animate__animated animate__fadeInUp">
                <img
                  src={slider_img_3}
                  alt="Doctor Slide 3"
                />
              </div>
            </div>
          </div>
        </div>

        {/* Controls */}
        <a
          className="carousel-control-prev"
          data-bs-target="#x_023_animated_layers"
          role="button"
          data-bs-slide="prev"
        >
          <span className="fa fa-angle-left" />
        </a>

        <a
          className="carousel-control-next"
          data-bs-target="#x_023_animated_layers"
          role="button"
          data-bs-slide="next"
        >
          <span className="fa fa-angle-right" />
        </a>
      </div>

      <div className="overlay" />
    </section>
  );
};

export default Slider;
